const install = function (Vue, options) {
  Vue.mixin({
    data() {
      return {
        device: '',
        breakpoints: {
          mobile: 320,
          tablet: 720,
          desktop: 1024,
          large: Infinity,
        },
      };
    },
    created() {
      if (options) this.breakpoints = options;

      this.device = this.checkDevice();

      window.addEventListener('resize', () => {
        this.device = this.checkDevice();
      });
    },
    methods: {
      checkDevice() {
        return window.innerWidth <= this.breakpoints.mobile
          ? 'mobile'
          : window.innerWidth <= this.breakpoints.tablet
            ? 'tablet'
            : window.innerWidth <= this.breakpoints.desktop
              ? 'desktop'
              : 'large';
      },
    },
    computed: {
      $tvaMq() {
        return this.device;
      },
    },
  });
};

export default install;
